export const ACSelectionPalette = [
  { background: '#F3F7FC', border: '#BEC9DA' },
  { background: '#FCF5F3', border: '#BEC9DA' },
  { background: '#F2FFFD', border: '#BEC9DA' },
  { background: '#FCFCF3', border: '#BEC9DA' },
  { background: '#F6F3FC', border: '#BEC9DA' },
  { background: '#FCF3F3', border: '#BEC9DA' },
  { background: '#F3FCF6', border: '#BEC9DA' },
  { background: '#FFF5F5', border: '#BEC9DA' },
  { background: '#F7F7F7', border: '#BEC9DA' },
  { background: '#FCF3FB', border: '#BEC9DA' },
];
